export default "/assets/images/pollen-video-thumbnail.jpg?b2c9d24d4a47db76dc00902c4afeaf5c";